/// <reference types="@types/googlemaps" />
import {AfterViewInit, Component, ViewChild} from "@angular/core";
import {Field} from "../models/field.model";
declare var google: any;

@Component({
	selector: "tig-form-input",
	template: `
	<div
		*ngIf="OBJ_form_group?.value?.latitude && OBJ_form_group?.value?.longitude"
		class="form-group"
		[formGroup]="OBJ_form_group">
		<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}"></label>
		<div class="col-lg-8">
			<div #googleMap style='width:100%;height:300px'></div>
		</div>
	</div>
  `
})
export class FormGoogleMapComponent extends Field implements AfterViewInit
{


	@ViewChild('googleMap', {static: false}) gMapElement: any;
	map: google.maps.Map;


	/**
	 * LifecycleHook > ngAfterViewInit
	 */
	ngAfterViewInit()
	{

		let coordinates = this.OBJ_form_group.getRawValue();
		if (coordinates.latitude && coordinates.longitude)
		{

			let	formControl = this.OBJ_form_group.get(this.OBJ_field_config.name),
				mapProp = {
					center: new google.maps.LatLng(coordinates.latitude, coordinates.longitude),
					zoom: 14,
					// HYBRID, ROADMAP, SATELLITE, TERRAIN
					mapTypeId: google.maps.MapTypeId.HYBRID
				};

			this.map = new google.maps.Map(this.gMapElement.nativeElement, mapProp);
			let marker = new google.maps.Marker({ position: mapProp.center });
			marker.setMap(this.map);

			// let infoWindow = new google.maps.InfoWindow({
			// 	content: 'Hey, We are here'
			// });
			//
			// infoWindow.open(this.map, marker);

		} // end if

	} // end function ngAfterViewInit


} // end class FormGoogleMapComponent
